var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"margin-top":"90px"},attrs:{"fluid":""}},[_c('video-player',{staticClass:"mx-auto",attrs:{"options":_vm.videoOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }